import React from "react";
import SelfStatusCell, { SelfStatusCellProps } from "../selfStatusCell";
import BaseLegendTable from "./baseLegendTable";
import { RaterStatusCellProps } from "../raterStatusCell";
import { ScoringStatusCellProps } from "../scoreStatusCell";

interface SelfLegendTableProps {}

const SelfLegendTable: React.FC<SelfLegendTableProps> = () => {
    const data: {
        cellData: SelfStatusCellProps;
        comment: string;
    }[] = [
        {
            cellData: { status: 5, scored: true, hasRaters: true },
            comment: "Assessment has been deactivated or cancelled",
        },
        {
            cellData: { status: 1, scored: true, hasRaters: true },
            comment: "Assessment has not been accessed by the Participant",
        },
        {
            cellData: { status: 2, scored: true, hasRaters: true },
            comment: "Participant has started but not completed the assessment",
        },
        {
            cellData: { status: 3, scored: true, hasRaters: true },
            comment: "Assessment is in the process of being scored",
        },
        {
            cellData: { status: 4, scored: false, hasRaters: true },
            comment: "Assessment is complete but not scored",
        },
        {
            cellData: { status: 4, scored: true, hasRaters: true },
            comment: "Assessment has been scored",
        },
    ];

    return (
        <BaseLegendTable
            statusCellType={
                SelfStatusCell as React.ElementType<
                    SelfStatusCellProps | RaterStatusCellProps | ScoringStatusCellProps
                >
            }
            data={data}
            title="Self Survey"
        />
    );
};

export default SelfLegendTable;
